import { Injectable } from '@angular/core';
import {
  FunctionGroup,
  FunctionObj,
  Plan,
  PlanFunctionGroups,
  S3Data,
  SignUpBox,
  WebsiteStatistics,
} from '../globals/types';
import { environment } from '../../environments/environment';

import { ApiRequest, ApiService } from './api.service';
import { Functions } from './functions.service';
import { FooterColumn, FooterLink, NavBarSettings } from '../modules/navbar/type';
import { forkJoin, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataSourceService {
  public s3Data: S3Data = {
    functionGroups: null,
    functions: null,
    navBarSettings: null,
    plans: null,
    planFunctionGroups: null,
    footer: null,
    websiteStatistics: null,
    signUpBox: null,
  } as unknown as S3Data;

  constructor(private apiService: ApiService, private functions: Functions) {}

  public init() {
    const time = Math.floor(Date.now() / 1000);

    return forkJoin<
      [
        { function_groups: FunctionGroup[] },
        { navBarSettings: NavBarSettings },
        { functions: FunctionObj[] },
        { plans: Plan[]; switch: any },
        { plan_function_groups: PlanFunctionGroups[] },
        { footerSettings: FooterColumn[] },
        { signUpBox: SignUpBox },
        WebsiteStatistics
      ]
    >([
      this.loadJsonData('/function-groups.json?' + time) as Observable<{ function_groups: FunctionGroup[] }>,
      this.loadJsonData('/navbar.json?' + time) as Observable<{ navBarSettings: NavBarSettings }>,
      this.loadJsonData('/functions.json?') as Observable<{ functions: FunctionObj[] }>,
      this.loadJsonData('/plans.json?' + time) as Observable<{ plans: Plan[]; switch: any }>,
      this.loadJsonData('/plan_function_groups.json?' + time) as Observable<{
        plan_function_groups: PlanFunctionGroups[];
      }>,
      this.loadJsonData('/footer.json?' + time) as Observable<{ footerSettings: FooterColumn[] }>,
      this.loadJsonData('/sign-up-box.json?' + time) as Observable<{ signUpBox: SignUpBox }>,
      this.loadJsonData('/website_statistics.json?' + time, environment.STATS_URL) as Observable<WebsiteStatistics>,
    ]).pipe(
      tap(
        ([
          { function_groups },
          { navBarSettings },
          { functions },
          { plans, switch: planSwitch },
          { plan_function_groups },
          { footerSettings },
          { signUpBox },
          websiteStatistics,
        ]: [
          { function_groups: FunctionGroup[] },
          { navBarSettings: NavBarSettings },
          { functions: FunctionObj[] },
          { plans: Plan[]; switch: any },
          { plan_function_groups: PlanFunctionGroups[] },
          { footerSettings: FooterColumn[] },
          { signUpBox: SignUpBox },
          WebsiteStatistics
        ]) => {
          this.s3Data.functionGroups = function_groups;
          this.s3Data.navBarSettings = navBarSettings;
          this.s3Data.functions = functions;
          this.s3Data.plans = plans;
          this.s3Data.planSwitch = planSwitch;
          this.s3Data.planFunctionGroups = plan_function_groups;
          // footer
          const source: FooterColumn[] = footerSettings;
          source.sort((a: FooterColumn, b: FooterColumn) => {
            return a.pos > b.pos ? 1 : -1;
          });
          source.forEach((obj: FooterColumn) => {
            obj.links.sort((a: FooterLink, b: FooterLink) => {
              return a.pos > b.pos ? 1 : -1;
            });
          });
          this.s3Data.footer = source;
          // signup box
          /*todo ez most mock.*/
          this.s3Data.websiteStatistics = websiteStatistics; /*{
            document_count: 5498463,
            invoice_analysis_subscription_business_count: 9462,
            subscriber_count: 122,
          }; //;*/
          this.s3Data.signUpBox = signUpBox;

          this.buildPlans();
        }
      )
    );
  }

  loadJsonData(link: string, microService = environment.S3_CONFIG) {
    const connection: ApiRequest = {
      link,
      params: {},
      method: 'GET',
      microService,
    };
    return this.apiService.getResponseFromMicroServiceSafe2(connection);
  }

  private buildPlans() {
    this.s3Data.plans.forEach((plan: Plan) => {
      plan.functions = [];
      // plan.highlightedFunctions = [];
      this.s3Data.functions.forEach((fn: FunctionObj) => {
        // let highlighted: HighlightedFunction | null = null;
        // if (fn.pos_highlighted) {
        //   highlighted = {
        //     pos: fn.pos_highlighted,
        //     exist: false,
        //     function: fn,
        //   };
        // }

        if (this.functions.indexOfNumber(fn.plan_ids, plan.id) > -1) {
          plan.functions.push(JSON.parse(JSON.stringify(fn)));
          // if (highlighted) {
          //   highlighted.exist = true;
          // }
        }

        // if (highlighted) {
        //   plan.highlightedFunctions.push(JSON.parse(JSON.stringify(highlighted)));
        // }
      });
      // plan.highlightedFunctions.sort((a: HighlightedFunction, b: HighlightedFunction) => {
      //   return a.pos > b.pos ? 1 : -1;
      // });
    });
  }
}
